module.exports = __webpack_public_path__ + "static/testimonialLayout1Front-741a8313a9e0775dd644457da39bf9f9.png";